export { default } from "ember-stereo/stereo-connections/native-audio";
